/**
 * Making a person (§5). Two paths: the roll, played back as a paragraph and
 * rerollable; or four questions that read as fiction. Both are the sim's;
 * this only shows them and takes an answer.
 */

import {
  answerGuided,
  type CharacterSheet,
  type Content,
  type GuidedAnswers,
  rollCharacter,
  type Seedable,
} from '@sim/index.ts';
import { useState } from 'react';

interface Props {
  readonly content: Content;
  readonly seed: Seedable;
  readonly onDone: (sheet: CharacterSheet) => void;
}

export function Chargen({ content, seed, onDone }: Props) {
  const [roll, setRoll] = useState(0);
  const [guided, setGuided] = useState<GuidedAnswers | null>(null);

  if (guided !== null) {
    const questions = content.chargen.questions;
    const asked = questions.find((q) => !(q.id in guided));
    if (!asked) {
      const sheet = answerGuided(content, seed, guided);
      return (
        <main className="make">
          <p className="who">{sheet.summary}</p>
          <div className="actions">
            <button type="button" className="choice" onClick={() => onDone(sheet)}>
              Go home
            </button>
            <button type="button" className="choice quiet" onClick={() => setGuided({})}>
              Start over
            </button>
          </div>
          <p className="seed">seed {String(seed)}</p>
        </main>
      );
    }
    return (
      <main className="make">
        <p className="ask">{asked.prompt}</p>
        <div>
          {asked.options.map((o) => (
            <button
              key={o.id}
              type="button"
              className="answer"
              onClick={() => setGuided({ ...guided, [asked.id]: o.id })}
            >
              {o.text}
            </button>
          ))}
        </div>
        <p className="seed">seed {String(seed)}</p>
      </main>
    );
  }

  const sheet = rollCharacter(content, seed, roll);
  return (
    <main className="make">
      <p className="who">{sheet.summary}</p>
      <div className="actions">
        <button type="button" className="choice" onClick={() => onDone(sheet)}>
          Go home
        </button>
        <button type="button" className="choice quiet" onClick={() => setRoll(roll + 1)}>
          Someone else
        </button>
        <button type="button" className="choice quiet" onClick={() => setGuided({})}>
          Answer for yourself
        </button>
      </div>
      <p className="seed">seed {String(seed)}</p>
    </main>
  );
}
